import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement('slds-dialog')
class SldsDialog extends SldsBaseElement {
  @property({ type: Boolean }) open = true;
  @property({ type: Boolean }) mandatory = false;

  static styles = [
    super.styles,
    css`
    h1, div {
        color: var(--text-color, #181818);
    }
    /* ::slotted(*) {
        color: var(--text-color, #181818);
    } */
    :host {
        --slds-c-modal-header-color-background: var(--background-color);
        --slds-c-modal-color-border: var(--border-color, #e5e5e5);
    }
    .slds-modal__header {
        background-color: var(--background-color, #f3f3f3);
        --slds-c-modal-color-border: var(--border-color, #e5e5e5);
    }
    .slds-modal__content {
        background-color: var(--background-color, #f3f3f3);
    }
    .slds-modal__footer {
        background-color: var(--background-color, #f3f3f3);
        --slds-c-modal-color-border: var(--border-color, #e5e5e5);
    }
    .slds-modal {
        background: rgba(0, 0, 0, 0.5);
    }
    `
  ];

  render() {
    return html`
    <section role="dialog" tabindex="-1" aria-modal="true" aria-labelledby="modal-heading-01" class="slds-modal ${this.open ? 'slds-fade-in-open' : ''}">
        <div class="slds-modal__container">
            ${this.mandatory ? '' : html`<button @click="${this._closeDialog}" class="slds-button slds-button_icon slds-modal__close">
                <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
                </svg>
                <span class="slds-assistive-text">Cancel and close</span>
            </button>`}
            <div class="slds-modal__header">
                <h1 id="modal-heading-01" class="slds-modal__title slds-hyphenate" tabindex="-1"><slot name="header"></slot></h1>
            </div>
            <div class="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
                <slot name="body"></slot>
            </div>
            <div class="slds-modal__footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </section>
    <div class="slds-backdrop slds-backdrop_open" role="presentation"></div>
    `;
  }

  _closeDialog() {
    this.dispatchEvent(new CustomEvent('close', { bubbles: true, composed: true }));
  }
}
